'use strict';

function resizeLogoOnScroll() {
  const distanceY = window.pageYOffset || document.documentElement.scrollTop;
  const shrinkOn = 200;
  const safeElm = document.createElement('div');
  const headerElm = document.querySelector('.header') || safeElm;

  if (distanceY >= shrinkOn) {
    headerElm.classList.add('on-scroll');
  } else if (distanceY === 0) {
    headerElm.classList.remove('on-scroll');
  }
}

window.addEventListener('scroll', resizeLogoOnScroll);
